// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/liquidazioni-iva/:id',
    requestBody: null,
    response: '{ success: true, data: {...}, runtime: {...}, dettaglioPerCodiceIva: [...], righeIvaPeriodo: [...], scritturePeriodo: [...], blocchiPreDefinitiva: [...] }'
  },
  {
    method: 'PATCH',
    endpoint: '/api/liquidazioni-iva/:id/definitiva',
    requestBody: null,
    response: '{ success: true, data: {...} }'
  },
  {
    method: 'PATCH',
    endpoint: '/api/liquidazioni-iva/:id/riapri',
    requestBody: null,
    response: '{ success: true, data: {...} }'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
